const DEFAULT_FPS = 30;

function getSceneDurationInFrames(scene, fps = DEFAULT_FPS) {
  if (scene.durationInFrames) return scene.durationInFrames;
  return Math.round((scene.duration || 4) * fps);
}

/**
 * Calculate which scene should be active at a given frame
 */
export function getActiveScene(frame, scenes, fps = DEFAULT_FPS) {
  let cumulativeFrames = 0;

  for (let i = 0; i < scenes.length; i++) {
    const scene = scenes[i];
    const durationInFrames = getSceneDurationInFrames(scene, fps);
    const sceneStart = cumulativeFrames;
    const sceneEnd = cumulativeFrames + durationInFrames;

    if (frame >= sceneStart && frame < sceneEnd) {
      return {
        scene,
        sceneIndex: i,
        sceneFrame: frame - sceneStart,
        sceneStart,
        sceneEnd,
      };
    }

    cumulativeFrames += durationInFrames;
  }

  return null;
}

/**
 * Calculate total duration of all scenes in frames
 */
export function getTotalDuration(scenes, fps = DEFAULT_FPS) {
  if (!scenes || !scenes.length) return 0;
  return scenes.reduce((total, scene) => total + getSceneDurationInFrames(scene, fps), 0);
}

/**
 * Get scene timing information for timeline display
 */
export function getSceneTimings(scenes, fps = DEFAULT_FPS) {
  let cumulativeFrames = 0;

  return scenes.map((scene, i) => {
    const durationInFrames = getSceneDurationInFrames(scene, fps);
    const start = cumulativeFrames;
    const end = cumulativeFrames + durationInFrames;
    cumulativeFrames = end;

    return {
      id: scene.id || `scene-${i}`,
      name: `Scene ${i + 1}`,
      start,
      end,
      duration: durationInFrames,
    };
  });
}
